import React, { useEffect, useState } from "react";
import { checkIfEmulating, initializeEmulationState } from "../../services/userService";

const UserIcon = ({ name, size = "md", bgColor = "bg-blue-500" }) => {
  const [isEmulating, setIsEmulating] = useState(checkIfEmulating());

  const refreshIcon = () => {
    setIsEmulating(checkIfEmulating());
  };

  useEffect(() => {
    initializeEmulationState();
    refreshIcon();
    window.addEventListener("refreshUserIcon", refreshIcon);
    setInterval(refreshIcon, 5000);
    return () => {
      window.removeEventListener("refreshUserIcon", refreshIcon);
    };
  }, []);

  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const sizeClasses = {
    sm: "w-8 h-8 text-sm",
    md: "w-12 h-12 text-base",
    lg: "w-16 h-16 text-lg",
  };

  const iconBgColor = isEmulating ? "bg-red-500" : bgColor;

  return (
    <div
      className={`${sizeClasses[size]} ${iconBgColor} rounded-full flex items-center justify-center text-white font-medium`}
    >
      {getInitials(name)}
    </div>
  );
};

export default UserIcon;
